import React, { useState, useRef, useEffect } from 'react';
import { Icon } from './Icon';
import { Input } from './Input';

export interface SearchInputProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  size?: 'sm';
  debounce?: number;
  autoFocus?: boolean;
  className?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder = 'Search…',
  size,
  debounce = 0,
  autoFocus,
  className = '',
}: SearchInputProps) {
  const [local, setLocal] = useState(value || '');
  useEffect(() => {
    setLocal(value || '');
  }, [value]);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const emit = (v: string) => {
    setLocal(v);
    if (debounce > 0) {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => onChange && onChange(v), debounce);
    } else {
      onChange && onChange(v);
    }
  };

  return (
    <div className={'search ' + className}>
      <span className="search-icon">
        <Icon name="search" size={size === 'sm' ? 15 : 16} />
      </span>
      <Input
        size={size}
        value={local}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onChange={(e) => emit(e.target.value)}
      />
      {local && (
        <button
          className="search-clear btn btn-ghost btn-icon btn-sm"
          onClick={() => emit('')}
          aria-label="Clear"
          style={{ height: 22, width: 22 }}
        >
          <Icon name="x" size={14} />
        </button>
      )}
    </div>
  );
}

export default SearchInput;
